import React from "react";
import { navigateToLogin } from "../../../history";
import UserIcon from "./UserIcon";
import styles from "./SignInButton.scss";

function SignInButton() {
  return (
    <a
      role="button"
      tabIndex={0}
      onClick={() => {
        navigateToLogin();
      }}
      rel="noopener noreferrer nofollow"
      className={`${styles.container} ${styles.text}`}
    >
      <UserIcon />
      {"Prijavi se"}
    </a>
  );
}

export default SignInButton;



// WEBPACK FOOTER //
// ./src/containers/UserMenu/SignInButton/SignInButton.tsx